import { createContext } from 'react'

import { createRichEditorStore } from '../store/createStore'

export const RichEditorStoreContext = createContext<
  ReturnType<typeof createRichEditorStore> | undefined
>(undefined)
